import { PRODUCT_CATEGORIES } from "../constants/categories";

const ORDER = PRODUCT_CATEGORIES.map((c) => c.value);

const rank = (category) => {
  const i = ORDER.indexOf(category);
  return i === -1 ? ORDER.length : i;
};

/**
 * Buckets `list` by category in the order categories are offered everywhere
 * else (juice first), with anything unrecognised last. Returns
 * [{ category, entries }] — empty categories are not returned.
 */
export function groupByCategory(list, getCategory) {
  const buckets = new Map();

  list.forEach((entry) => {
    const category = getCategory(entry) || "other";
    if (!buckets.has(category)) buckets.set(category, []);
    buckets.get(category).push(entry);
  });

  return Array.from(buckets, ([category, entries]) => ({ category, entries })).sort(
    (a, b) => rank(a.category) - rank(b.category) || a.category.localeCompare(b.category)
  );
}

export const plural = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;
